import { Redirect, Route, Switch } from "react-router-dom";

import { UsersProvider } from "contexts/UsersContext";
import { KpisManagePage } from "pages/Kpis/KpisManagePage";
import { KpisPage } from "pages/Kpis/KpisPage";

export const KpisRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/kpis/manage">
        <UsersProvider>
          <KpisManagePage />
        </UsersProvider>
      </Route>

      <Route exact path="/pages/kpis/:id?">
        <UsersProvider>
          <KpisPage />
        </UsersProvider>
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/kpis" from="/pages/kpis" />
      <Redirect to="/pages" />
    </Switch>
  );
};
